"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENT_VERSION = exports.VERSIONS = void 0;

var _keymirror = _interopRequireDefault(require("keymirror"));

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
var VERSIONS = (0, _keymirror["default"])({
  v0: null,
  v1: null
});
exports.VERSIONS = VERSIONS;
var CURRENT_VERSION = VERSIONS.v1;
exports.CURRENT_VERSION = CURRENT_VERSION;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy92ZXJzaW9ucy50cyJdLCJuYW1lcyI6WyJWRVJTSU9OUyIsInYwIiwidjEiLCJDVVJSRU5UX1ZFUlNJT04iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUdBOztBQUhBO0FBQ0E7QUFJTyxJQUFNQSxRQUFRLEdBQUcsMkJBQVU7QUFDaENDLEVBQUFBLEVBQUUsRUFBRSxJQUQ0QjtBQUVoQ0MsRUFBQUEsRUFBRSxFQUFFO0FBRjRCLENBQVYsQ0FBakI7O0FBS0EsSUFBTUMsZUFBZSxHQUFHSCxRQUFRLENBQUNFLEVBQWpDIiwic291cmNlc0NvbnRlbnQiOlsiLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IE1JVFxuLy8gQ29weXJpZ2h0IGNvbnRyaWJ1dG9ycyB0byB0aGUga2VwbGVyLmdsIHByb2plY3RcblxuaW1wb3J0IGtleU1pcnJvciBmcm9tICdrZXltaXJyb3InO1xuXG5leHBvcnQgY29uc3QgVkVSU0lPTlMgPSBrZXlNaXJyb3Ioe1xuICB2MDogbnVsbCxcbiAgdjE6IG51bGxcbn0pO1xuXG5leHBvcnQgY29uc3QgQ1VSUkVOVF9WRVJTSU9OID0gVkVSU0lPTlMudjE7XG4iXX0=